import React, { useState } from 'react';
import axios from 'axios';
import '../styles/infoReserva.css';

const InfoReserva = () => {
    const [formData, setFormData] = useState({ idReserva: '', rut: '' });
    const [reservaData, setReservaData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const bearerToken = process.env.REACT_APP_BEARER_TOKEN;

    // Función para manejar el cambio en ambos inputs
    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [id]: value,
        }));
    };

    // Función para manejar la búsqueda de la reserva
    const handleSearch = async () => {
        setLoading(true);
        setError(null);
        
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL_INFO_RESERVA_CLIENTE}`, {
                headers: { Authorization: `Bearer ${bearerToken}` },
                params: { rsa_codigo: formData.idReserva, int_nrodocidentidad: formData.rut }
            });
            setReservaData(response.data);
        } catch (err) {
            setError('Error al cargar la información de la reserva.');
            console.error('Error al cargar la información de la reserva:', err);
        } finally {
            setLoading(false);
        }
    };

    // Función para manejar el evento "Enter" en los inputs
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    return (
        <div className="info-reserva-container">
            <h1>Buscar Reserva por Cliente</h1>
            <div className="search-bar">
                <label className="infoReserva-label" htmlFor="idReserva">ID Reserva:</label>
                <input
                    className="infoReserva-input"
                    type="text"
                    id="idReserva"
                    value={formData.idReserva}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    placeholder="Ingrese el ID de la reserva"
                />
                <label className="infoReserva-label" htmlFor="rut">Rut:</label>
                <input
                    className="infoReserva-input"
                    type="text"
                    id="rut"
                    value={formData.rut}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    placeholder="Ingrese rut del cliente"
                />
                <button className="infoReserva-button" onClick={handleSearch} disabled={loading}>
                    {loading ? 'Buscando...' : 'Buscar'}
                </button>
            </div>
            {error && <p className="error">{error}</p>}
            {reservaData && (
                <div className="json-container">
                    <pre>{JSON.stringify(reservaData, null, 2)}</pre>
                </div>
            )}
        </div>
    );
};

export default InfoReserva;
